import React from 'react';
import { FadeIn } from './FadeIn';
export function StatsBanner() {
  const stats = [{
    number: '46%',
    text: 'de latinoamericanos sufrió burnout en 2024'
  }, {
    number: '72%',
    text: 'de mexicanos reportó burnout el último año'
  }, {
    number: '21 Días',
    text: 'al primer resultado medible'
  }, {
    number: '8',
    text: 'intervenciones con evidencia científica'
  }];
  return <section className="py-12 bg-brand-cream border-y border-brand-sage border-opacity-20" data-id="element-184">
      <div className="max-w-6xl mx-auto px-6" data-id="element-185">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-6" data-id="element-186">
          {stats.map((stat, index) => <FadeIn key={index} delay={0.1 * index} direction="up" className="text-center" data-id="element-187">
              <div className="text-3xl md:text-4xl font-serif font-bold text-brand-terracotta mb-2" data-id="element-188">
                {stat.number}
              </div>
              <div className="text-sm md:text-base text-brand-charcoal font-medium leading-tight" data-id="element-189">
                {stat.text}
              </div>
            </FadeIn>)}
        </div>
        <FadeIn delay={0.5} data-id="element-190">
          <p className="text-center text-xs text-brand-gray italic" data-id="element-191">
            Fuentes: Estudio Buk 2025, LatinUS/APA 2025
          </p>
        </FadeIn>
      </div>
    </section>;
}